import React, { useState, useEffect } from 'react';
import { Table, TableBody, Grid, TableCell,MenuItem, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import AddOportunidad from './AddOportunidad';
import { useAccesos } from '../contexts/AccesosContext';




function GestionOportunidad() {

    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [oportunidades, setOportunidades] = useState([]);
    const [etapas, setEtapas] = useState([]);
    const [selectOportunidad, setSelectOportunidad] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [etapaFiltro, setEtapaFiltro] = useState('');
    const [oportunidadToDelete, setOportunidadToDelete] = useState(null);
    const { user } = useUser();   
    const { tienePermiso } = useAccesos();

     
        const fetchEtapas = async () => {
            try {
            const response = await fetch(`${server}/CrmEtapaOportunidads`); 
            const data = await response.json();
            setEtapas(data.$values);
            } catch (error) {
            console.error('Error al cargar etapas:', error);
            }
        };

    const fetchOportunidades = async (idEtapaOportunidad = '') => {
        try {
            const url = idEtapaOportunidad
                ? `${server}/CrmOportunidads/poridEtapa/${idEtapaOportunidad}`
                : `${server}/CrmOportunidads`
            const response = await fetch(url);
            const data = await response.json();
            setOportunidades(data.$values);
        } catch (error) {
            Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error al cargar las Oportunidades: ' + error,
            });
        }
    };

            useEffect(() => {
                fetchEtapas();
                fetchOportunidades();
                // fetchEtapas();
            }, []);

            useEffect(() => {
                fetchOportunidades(etapaFiltro);
            }, [etapaFiltro]);
        
            // const handleNewOportunidad = () => {
            //     fetchOportunidades();
            //     setSelectOportunidad(null); // selecciona en lugar de editar
            // };

              const handleSeleccionarOportunidad = (oportunidad) => {
               fetchOportunidades(etapaFiltro);
                setSelectOportunidad(oportunidad); // Establecer la oportunidad seleccionada
            };

        
            const handleChangePage = (event, newPage) => {
                setPage(newPage);
            };
        
            const handleChangeRowsPerPage = (event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
            };
        
            const handleSearchChange = (event) => {
                setSearchQuery(event.target.value);
            };
        
            const handleOpenDialog = (oportunidad) => {
                setOportunidadToDelete(oportunidad);
                setOpenDialog(true);
            };
        
            const handleCloseDialog = () => {
                setOpenDialog(false);
                setOportunidadToDelete(null);
            };
        
            const handleDeleteOportunidad = async () => {
                if (oportunidadToDelete) {
                    try {
                        const username = ''+user.codigoUsuario+'/';
                        const response = await fetch(`${server}/CrmOportunidads/${oportunidadToDelete.id}/${username}`,
                             {
                            method: 'DELETE'
                        });
                        if (response.ok) {
                            handleCloseDialog();
                            fetchOportunidades(); // Recargar la lista de campanias
                            Swal.fire({
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Oportunidad eliminada con éxito',
                            });
                        } else {
                            handleCloseDialog();
        
                            const errorData = await response.json();
                            const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                            Swal.fire({
                                icon: 'error',
                                title: `Error ${response.status}`,
                                text: errorMessage,
                            });
                        }
                    } catch (error) {
                        console.error('Error al eliminar la oportunidad:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al eliminar la oportunidad: ' + error,
                        });            }
                }
            };
  
            const filteredOportunidad = oportunidades.filter(oportunidad => oportunidad.nombreOportunidad?.toLowerCase().includes(searchQuery.toLowerCase()));
    

return (
<>
    <div className="x_title"></div>
        <div className="x_content">
        <div className="row">
            
            <br />

            <div className="col-md-9 col-sm-4 offset-md-2">
            <div className="ln_solid" />

            <h2>Oportunidades existentes</h2>

           
            <Grid container spacing={2} alignItems="center" style={{ marginBottom: '20px' }}>
                <Grid item xs={14} sm={9}>
                    <TextField
                    variant="outlined"
                    label="Buscar oportunidad"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    fullWidth
                    />
                </Grid>
                 <Grid item xs={12} sm={6} md={3}>
                               <TextField
                                    select
                                    fullWidth
                                    label="Filtrar por Etapa"
                                    value={etapaFiltro}
                                    onChange={(e) => setEtapaFiltro(e.target.value)}
                                    variant="outlined"
                                >
                                    <MenuItem value="">Todos</MenuItem>
                                    {etapas.map((etapa) => (
                                        <MenuItem key={etapa.id} value={etapa.id}>
                                            {etapa.etapa}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                </Grid>
                
            </Grid>

                <div style={{ width: '100%', overflowX: 'auto', display:'block' }}>
                 <TableContainer component={Paper} style={{ width:"100%", overflowX:'auto'}}>
                    <Table style={{ minWidth: '1700px'}}>
                    <TableHead>
                        <TableRow>
                        <TableCell align="right">Acciones</TableCell>
                        <TableCell> Nombre</TableCell>
                        <TableCell>Valor monetario</TableCell>
                        <TableCell>Fecha cierre propuesta</TableCell>
                        <TableCell>Fecha cierre</TableCell>
                        <TableCell >Etapa</TableCell>
                        <TableCell>Id Cliente</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap'}}>Nombre Cliente</TableCell>
                        <TableCell>Probabilidad</TableCell>
                        <TableCell>Origen</TableCell>
                        <TableCell>Sucursal</TableCell>
                        <TableCell>Id Cotizacion</TableCell>
                        <TableCell>Id Orden</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap'}}>Número de factura inicial</TableCell>
                        
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredOportunidad.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((oportunidad) => (
                            <TableRow key={oportunidad.id}>
                            <TableCell align="right">
                                <Button onClick={() => setSelectOportunidad(oportunidad)} color="primary" disabled={!tienePermiso('Editar Oportunidad')}>
                                   Ver
                                </Button>
                                <Button onClick={() => handleOpenDialog(oportunidad)} color="secondary" disabled={!tienePermiso('Eliminar Oportunidad')}>
                                    Eliminar
                                </Button>
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {oportunidad.nombreOportunidad}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {oportunidad.valorMonetario}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {oportunidad.fechaCierrePropuesta}
                            </TableCell>
                             <TableCell component="th" scope="row">
                                {oportunidad.fechaCierre}
                            </TableCell>
                            <TableCell component="th" scope="row">
                            {/* {tarea.prioridad} */}
                                         <span style={{
                                            padding: '4px 8px',
                                            borderRadius: '5px',
                                            color: 'white',
                                            whiteSpace: 'nowrap',
                                            backgroundColor:
                                            oportunidad.etapa?.toLowerCase() === 'abierta' ? 'lightgray' :
                                            oportunidad.etapa?.toLowerCase() === 'cotizada' ? 'orange' :
                                            oportunidad.etapa?.toLowerCase() === 'cerrada ganada' ? 'green' :
                                            oportunidad.etapa?.toLowerCase() === 'cerrada perdida' ? 'red' :
                                            ''
                                            
                                        }}>
                                {oportunidad.etapa}
                                </span>
                            </TableCell>
                            <TableCell component="th" scope="row">
                               <strong>{oportunidad.idCliente}</strong>
                            </TableCell>
                            <TableCell component="th" scope="row" sx={{ whiteSpace: 'nowrap'}}>
                                {oportunidad.nombreCompleto}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {oportunidad.probabilidadOport}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {oportunidad.origen}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {oportunidad.sucursal}
                            </TableCell>
                             <TableCell component="th" scope="row">
                                {oportunidad.idCotizacion}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {oportunidad.idOrdenMes}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {oportunidad.factura ? oportunidad.factura.numeroFactura : ''}
                            </TableCell>
                            </TableRow>
                           ))}  
                    </TableBody>
                    </Table>
                    <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={oportunidades.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </div>
            </div>
            <br/>
            <div className="col-md-9 col-sm-4 offset-md-2">
            <AddOportunidad handleSeleccionarOportunidad={handleSeleccionarOportunidad} selectOportunidad={selectOportunidad}/>
            </div>
                <Dialog open={openDialog}
                    onClose={handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                        <DialogContent>
                           <DialogContentText id="alert-dialog-description">
                                ¿Estás seguro de que quieres eliminar esta oportunidad?
                            </DialogContentText>
                        </DialogContent>
                    <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                    <Button onClick={handleDeleteOportunidad} color="primary" autoFocus>Eliminar</Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    </>

     
    );
}

export default GestionOportunidad;